import { Stack } from '@mui/material';
import { Caption, Section as TSection } from '@telegram-apps/telegram-ui';
import type { CSSProperties, FC, ReactNode } from 'react';
import { CustomSection } from './CustomSection';
import { DotProgress } from './DotProgress';

export type TierListSectionProps = {
  title: string;
  titleCaptionStyle?: CSSProperties;
  headerColor?: string;
  hideHeaderText?: boolean;
  isFirst?: boolean;
  isCompleted?: boolean;
  showProgress: boolean;
  done: number;
  total: number;
  dotOverdue?: boolean;
  summaryWhenNoProgress: string;
  sectionStyle?: CSSProperties;
  headerAside?: ReactNode;
  accentBarColor?: string;
  innerSectionStyle?: CSSProperties;
  headerStyle?: CSSProperties;
  flat?: boolean;
  hideDivider?: boolean;
  independentRows?: boolean;
  children: ReactNode;
};

export const TierListSection: FC<TierListSectionProps> = ({
  title,
  titleCaptionStyle,
  headerColor,
  hideHeaderText,
  isFirst,
  isCompleted,
  showProgress,
  done,
  total,
  dotOverdue,
  summaryWhenNoProgress,
  sectionStyle,
  headerAside,
  innerSectionStyle,
  headerStyle,
  flat,
  hideDivider,
  independentRows,
  children,
}) => {
  const resolvedColor = headerColor ?? 'var(--tg-theme-section-header-text-color)';

  return (
    <Stack
      style={{
        marginTop: isFirst === false ? 10 : isFirst === true ? 0 : undefined,
        ...sectionStyle,
      }}
    >
      <TSection.Header
        style={{
          color: resolvedColor,
          paddingTop: isCompleted ? 5 : 0,
          paddingBottom: isCompleted ? 0 : 10,
          ...headerStyle,
        }}
      >
        {hideHeaderText ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            aria-hidden
            style={{ visibility: 'hidden' }}
          >
            <Caption style={titleCaptionStyle}>&nbsp;</Caption>
            <Caption>&nbsp;</Caption>
          </Stack>
        ) : (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Caption style={titleCaptionStyle}>{title}</Caption>
            {headerAside != null ? (
              headerAside
            ) : (
              <Stack direction="row" alignItems="center" gap={1}>
                <Caption>{showProgress ? `${done} / ${total}` : summaryWhenNoProgress}</Caption>
                {showProgress ? <DotProgress done={done} total={total} overdue={dotOverdue} /> : null}
              </Stack>
            )}
          </Stack>
        )}
      </TSection.Header>
      {independentRows ? (
        <Stack gap={1} style={{ marginBottom: 0, ...innerSectionStyle }}>
          {children}
        </Stack>
      ) : (
        <CustomSection hideTappable hideDivider={hideDivider} flat={flat} style={{ marginBottom: 0, ...innerSectionStyle }}>
          {children}
        </CustomSection>
      )}
    </Stack>
  );
};
